import React from "react";
import { useTheme } from "@mui/material/styles";
import { Box, Icon } from "@mui/material";
import SettingsIcon from '@mui/icons-material/Settings';

const FooterComponent = () => {
  const theme = useTheme();
  const buttonData = [
    /**{ text: "E-SIC", path: "https://esic.cmserracaiada.rn.gov.br/index/" },
    { text: "OUVIDORIA", path: "/ouvidoria" },
    { text: "RECEITA PREVISTA E ARRECADADA", path: "/receita-prevista" },
    { text: "DESPESA EMPENHADA, LIQUIDADA", path: "/despesa-empenhada" },
    { text: "FOLHA DE PAGAMENTO", path: "/folha-pagamento" },
    { text: "LICITAÇÕES", path: "/licitacoes" },
    { text: "CONTRATOS", path: "/contratos" },
    { text: "CONVÊNIOS", path: "/convenios" },
    { text: "LEIS", path: "/leis" },
    { text: "DECRETOS", path: "/decretos" },
    { text: "PORTARIAS", path: "/portarias" },
    { text: "DIÁRIAS", path: "/diarias" },
    { text: "PUBLICAÇÕES", path: "/publicacoes" },
    { text: "DADOS INSTITUCIONAIS", path: "/dados-institucionais" },
    { text: "BRASÃO, HINO E BANDEIRA", path: "/simbolos" },
    { text: "PREFEITO E VICE", path: "/prefeito-e-vice" },
    { text: "SECRETARIAS", path: "/secretarias" },
    { text: "CONSELHOS E MEMBROS", path: "/conselhos" },
    { text: "GLOSSÁRIO", path: "/glossario" },
    { text: "PERGUNTAS FREQUENTES FAQ", path: "/faq" },
    { text: "VEÍCULOS", path: "/veiculos" },
    { text: "COVID-19", path: "/covid-19" },
    { text: "MAPA DO SITE", path: "/mapa-do-site" },
    { text: "DADOS ABERTOS", path: "/dados-abertos" },
    { text: "CONTATOS", path: "/contatos" },
    { text: "ASSOCIAÇÕES", path: "/associacoes" },
    { text: "PROC. SELETIVO / CONCURSO PÚBLICO", path: "/concursos" },
    { text: "FALE CONOSCO", path: "/fale-conosco" },
    { text: "ESTRUTURA ORGANIZACIONAL", path: "/estrutura-organizacional" },
    { text: "TERCEIRIZADOS", path: "/terceirizados" },
    { text: "ESTAGIÁRIOS", path: "/estagiarios" },
    { text: "PESQUISA DE SATISFAÇÃO", path: "/pesquisa-satisfacao" },
    { text: "OBRAS", path: "/obras" },
    { text: "CARTA DE SERVIÇO", path: "/carta-servico" },
    {
      text: "RECEITAS DE EMENDAS PARLAMENTARES",
      path: "/emendas-parlamentares",
    },
    { text: "ORDEM CRONOLÓGICA", path: "/ordem-cronologica" },
    { text: "INFORMAÇÕES DESCLASSIFICADAS", path: "/info-desclassificadas" },
    { text: "INFORMAÇÃO POR GRAU DE SIGILO", path: "/grau-sigilo" },
    { text: "ESTATÍSTICA DE ATENDIMENTOS", path: "/estatisticas" },
    { text: "INCENTIVOS À CULTURA", path: "/incentivos-cultura" },*/
  ];

  return (
    <footer>
      <Box>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3967.1791629491063!2d-35.7129049!3d-6.106562!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b2173c2ef19b7f%3A0x66e2593e84aee184!2sR.%20Nossa%20Sra.%20da%20Concei%C3%A7%C3%A3o%2C%20334%2C%20Serra%20Caiada%20-%20RN%2C%2059245-000!5e0!3m2!1spt-PT!2sbr!4v1736962894247!5m2!1spt-PT!2sbr"
          title="Localização da prefeitura no google maps"
          width="100%"
          height="150"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </Box>
      <Box
        sx={{
          backgroundColor: "#4c4a64",
          color: theme.palette.primary.text,
          fontFamily: "Arial, sans-serif",
          padding: "20px 0",
        }}
      >
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "10px",
            marginBottom: "20px",
          }}
        >
          {buttonData.map((button, index) => (
            <button
              key={index}
              onClick={() => (window.location.href = button.path)}
              style={{
                backgroundColor: theme.palette.primary.main,
                border: "none",
                borderRadius: "5px",
                color: theme.palette.primary.text,
                padding: "10px 15px",
                cursor: "pointer",
                fontSize: "12px",
                transition: "background-color 0.3s",
              }}
              onMouseOver={(e) =>
                (e.target.style.backgroundColor = theme.palette.primary.dark)
              }
              onMouseOut={(e) =>
                (e.target.style.backgroundColor = theme.palette.primary.main)
              }
            >
              {button.text}
            </button>
          ))}
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "20px",
            flexWrap: "wrap",
            padding: "20px",
          }}
        >
          <div
            style={{
              backgroundColor: "#3a3a5c",
              borderRadius: "10px",
              padding: "20px",
              width: "300px",
              textAlign: "center",
              color: theme.palette.primary.text,
            }}
          >
            <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
              INSTITUCIONAL
            </div>
            <p style={{ margin: "5px 0" }}>
              👤 Presidente: Cristilene Bezerra de Azevedo
            </p>
            <p style={{ margin: "5px 0" }}>💳 CNPJ: 08.078.412/0001-56</p>
          </div>

          <div
            style={{
              backgroundColor: "#3a3a5c",
              borderRadius: "10px",
              padding: "20px",
              width: "300px",
              textAlign: "center",
              color: theme.palette.primary.text,
            }}
          >
            <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
              CONTATOS
            </div>
            <p style={{ margin: "5px 0" }}>📞 (84)3190-3179</p>
            <p style={{ margin: "5px 0" }}>✉ ouvidoria@cmserracaiada.rn.gov.br</p>
          </div>

          <div
            style={{
              backgroundColor: "#3a3a5c",
              borderRadius: "10px",
              padding: "20px",
              width: "300px",
              textAlign: "center",
              color: theme.palette.primary.text,
            }}
          >
            <div style={{ fontWeight: "bold", marginBottom: "10px" }}>
              ENDEREÇO E HORÁRIO
            </div>
            <p style={{ margin: "5px 0" }}>
              📍 R. Nossa Sra. da Conceição, Nº 334 Serra Caiada, RN, CEP:
              59245-000
            </p>
            <p style={{ margin: "5px 0" }}>
              🕒 De Segunda à Sexta de 07h00 às 13h00
            </p>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            padding: "10px",
            backgroundColor: theme.palette.primary.main,

          }}
        >
          <Box sx={{ display: "flex", justifyContent: "center", gap: "15px", alignItems: "center" }}>
            <p style={{ margin: "0", fontSize: "14px" }}>
              &copy; 2025 Prime Brasil. Todos os Direitos Reservados.
            </p>
            <a href="/admin" style={{ color: "inherit", textDecoration: "none", display: "flex", alignItems: "center" }}>
              <SettingsIcon />
            </a>
          </Box>
        </div>
      </Box>
    </footer>
  );
};

export default FooterComponent;
